/* jshint esversion: 6 */
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppActions } from 'app/redux/actions.js';
import axios from 'axios';

export default function api(type, state$, id, post, successCallback) {
    let generateUrl = (type, state$, id) => {
    		let path = "",
    			i = 0,
    			endpoint = [],
    			baseUrl = [],
                url = '',
                matches = null;

            if (type.match(/^\//)) {
                return type;
            }

            let config = state$.value.app.config;

            endpoint = config.endpoints[type];
            baseUrl = config.apiUrl;

            // login urls do not talk to the api (at this point)
            if (type.match("APP_")) {
                baseUrl = config.appUrl;
            }

    		if (endpoint.match('utilities')) {
    			baseUrl = state$.value.app.config.appUrl;
    		}

            url = [baseUrl, endpoint].join("");

            if (id) {
                if ((matches = url.match(/(:[a-zA-Z]+)$/)) !== null)  {
                    url = url.replace(matches[1], id);
                }
            }

    		return url;
    	},
        settings = {
            crossDomain: true,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json'
            },
            responseType: 'json'
        };

    settings.url = generateUrl(type, state$, id);

    if (post !== undefined && post !== null) {
        // special case places where the data is passed in 'post' but the request should
        // actually be GET
        if (!type.match("UTILITIES_URL_INFO_FETCH")) {
            settings.method = 'POST';
            settings.body = post;
        }
        if (post instanceof FormData) {
            delete settings.headers;
        }
        if (settings.url.match(/\:id/) && post.id !== undefined) {
            settings.url = settings.url.replace(/\:id/, post.id);
        } else if (settings.url.match(/\:socialId/) && post.socialId !== undefined) {
            settings.url = settings.url.replace(/\:socialId/, post.socialId);
        } else if (settings.url.match(/\:token/) && post.token !== undefined) {
            settings.url = settings.url.replace(/\:token/, post.token);
        }
    }

    let networkStart = new Date().getTime();

    return ajax(settings).pipe(
        map((response) => {
            if (response.xhr.getResponseHeader('x-dlvrit-version') !== undefined) {
                let version = response.xhr.getResponseHeader('x-dlvrit-version');
                if (version && window.DlvrConstants.VERSION && (version != window.DlvrConstants.VERSION)) {
                    window.location.reload();
                }
            }
            return successCallback.apply(this, [response.response]);
        }),
        catchError((error, stream) => {
            switch (error.status) {
                case 401:
                case 403:
                    return of(AppActions.apiError({
                            type: 'APP_SET_USER_SESSION',
                            error: 'Timed out'
                        }));

                // A 500 due to a server side fatal doesn't have a status 500 because the request never finished
                // because 500, so the proper way to catch the 500 is to look for a
                // status 0. However, browser timeouts also have a status 0 and no other discernable properties
                // to distinguish them from actual issues, so look for pairs in the ui error log
                case 0:
                    let networkElapsed = new Date().getTime() - networkStart;
                    axios({
                        url: `${state$.value.app.config.apiUrl}/error/report`,
                        data: {
                            userId: state$.value.user.detail.id,
                            error: 'Network Error',
                            errorInfo: JSON.stringify({
                                errorInfo: error.request.url,
                                browser: window.navigator.userAgent,
                                request: error.request,
                                location: window.location,
                                elapsed: networkElapsed / 1000
                            })
                        },
                        headers: { "Content-type": "multipart/form-data" },
                        method: 'POST',
                        withCredentials: true,
                        responseType: 'json'
                    });
                    return of(AppActions.apiError({
                            type,
                            error: {
                                errors: 'Network Error',
                                isNetworkError: true
                            },
                            post
                        }));

                default:
                    return of(AppActions.apiError({
                            type,
                            error: error.response,
                            post
                        }));
            }

        })
    );
}
